import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/imgcaptions/aiLogo.png'


const _hoisted_1 = { class: "userListBox" }
const _hoisted_2 = { class: "itemBox" }
const _hoisted_3 = { class: "itemBoxInner" }
const _hoisted_4 = ["onClick", "onMousemove"]
const _hoisted_5 = { class: "itemBoxOne" }
const _hoisted_6 = { class: "itemBoxImg" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  src: _imports_0,
  alt: ""
}
const _hoisted_9 = { class: "itemBoxTxt" }
const _hoisted_10 = { class: "itemBoxBtn" }

import { computed, ref, onMounted,getCurrentInstance } from "vue";
// 接口
import ChatGtpUserApi from "@/api/chatGtp/Index"
import Color from "element-plus/es/components/color-picker/src/utils/color";
import { emitChangeFn } from "element-plus";

import {
    Right,
} from '@element-plus/icons-vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'AssistantList',
  emits: ['reassistant'],
  setup(__props, { emit: __emit }) {

//   import Avatar from "@/components/Avatar.vue";
let { proxy } = getCurrentInstance()
const chatGtpUserList = ref([] as any[])
const chatGtpId = ref('')
const checkIndex = ref(-1)
const checkStyle = {
    'border': "1px solid #207CF6",
    'background':'rgba(32,124,246,0.1)' 
}
const overChat=(index:number)=>{
    checkIndex.value=index
}
const outChat=()=>{
    checkIndex.value=-1
}
const pageNum=ref(1)
const pageSize=ref(100)
onMounted(() => {
    ChatGtpUserApi.QueryGtpUser(1,100).then(resdata => {
        chatGtpUserList.value = resdata.rows
        //  
    })
})
// 选择助手
const checkChat = (id: string, index: number) => {
    // console.log('点击助手'+id)
    // console.log('点击助手'+index)
    chatGtpId.value = id
    checkIndex.value = index
    openChat()

}
// 开始聊天
const emit = __emit
const openChat = () => {
    if (chatGtpId.value == '') {
        emit('reassistant', '0')
        // console.log('暂时没有聊天助手')
        return;
    } else {
        emit('reassistant', chatGtpId.value)
    }
}
// 



return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "title" }, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "titleText" }, [
        _createElementVNode("span", { class: "titleTextTop" }, "选择助手"),
        _createElementVNode("span", { class: "titleTextBtm" }, "选择一个助手陪你聊天吧，您也可以不选择直接开始")
      ], -1)),
      _createElementVNode("div", { class: "titleBtn" }, [
        _createElementVNode("div", {
          class: "titleBtnInner",
          onClick: openChat
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("span", null, "直接开始", -1)
        ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_scrollbar, { height: "100%" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatGtpUserList.value, (oneUser, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: index,
                onClick: _withModifiers(($event: any) => (checkChat(oneUser.id, index)), ["stop"]),
                style: _normalizeStyle(checkIndex.value == index ? checkStyle : ''),
                onMousemove: ($event: any) => (overChat(index)),
                onMouseout: outChat
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (oneUser.avatar!=undefined)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(proxy).getimgUrl+ oneUser.avatar,
                          alt: ""
                        }, null, 8, _hoisted_7))
                      : _createCommentVNode("", true),
                    (oneUser.avatar==undefined)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, _toDisplayString(oneUser.name), 1)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, _toDisplayString(oneUser.intro) + " " + _toDisplayString(oneUser.intro), 1)
                  ], 512), [
                    [_vShow, checkIndex.value != index]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_10, _cache[2] || (_cache[2] = [
                    _createElementVNode("span", null, "开始对话", -1)
                  ]), 512), [
                    [_vShow, checkIndex.value == index]
                  ])
                ])
              ], 44, _hoisted_4))
            }), 128))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})